import { render, staticRenderFns } from "./mb-page-layout.vue?vue&type=template&id=24057405&scoped=true&"
import script from "./mb-page-layout.vue?vue&type=script&lang=js&"
export * from "./mb-page-layout.vue?vue&type=script&lang=js&"
import style0 from "./mb-page-layout.vue?vue&type=style&index=0&id=24057405&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24057405",
  null
  
)

export default component.exports